import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createProvider } from './vue-apollo'
import axios from 'axios';
import VueAxios from 'vue-axios';
import '../node_modules/ress'
import './assets/styles/wp.css'
import './assets/styles/style.styl'

import DefaultLayout from '@/layouts/DefaultLayout.vue';
// import TopLayout from '@/layouts/TopLayout.vue';


Vue.config.productionTip = false

Vue.directive('scroll', {
  inserted: (el, binding) => {
    const f = (evt) => {
      if ( binding.value(evt, el) ) {
        window.removeEventListener('scroll', f)
      }
    };
    window.addEventListener('scroll', f)
  },
})

if ( navigator.platform.indexOf('Win') !== -1 ) {
  document.querySelector('body').classList.add('win')
} else {
  document.querySelector('body').classList.add('mac')
}

// グローバル登録
Vue.component('default-layout', DefaultLayout)
// Vue.component('top-layout', TopLayout)

Vue.mixin({
  methods: {
    // オブジェクト・配列をディープコピーする場合
    getDuplicateObject (object) {
      const duplicate = Object.assign({}, JSON.parse(JSON.stringify(object)))
      return duplicate
    },
    getDuplicateArray (array) {
      const duplicate = Object.assign([], JSON.parse(JSON.stringify(array)))
      return duplicate
    },
    getFormatDate (date) {
      // console.log(date)
      const d = new Date(date)
      const yyyy = d.getFullYear()
      const mm = (d.getMonth() + 1).toString().padStart(2, '0')
      const dd = d.getDate().toString().padStart(2, '0')
      return yyyy + '/' + mm + '/' + dd
    },
  },
})

Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  axios,
  VueAxios,
  // ローカル登録
  // components: {
  //   'default-layout': DefaultLayout,
  //   'top-layout': TopLayout
  // },
  render: h => h(App)
}).$mount('#app')
